'use client';

import { LabelWithLinkMasking } from '../../../label';
import type { LinkNode } from 'data-layer/src/lib/transformers/types';
import { createFooterClickHandler } from '../../utils/clickHandler';
import { TEXT_VARIANT } from '@pixum/text';

export function TextLink(link: LinkNode) {
  const { url, title, mouseOverText } = link;

  return (
    <LabelWithLinkMasking
      href={url}
      key={`footer-link-text-${title}`}
      onClick={createFooterClickHandler(link)}
      text={title}
      title={mouseOverText || title}
      variant={TEXT_VARIANT.CAPTION}
      masked={link.masked}
    />
  );
}
